
import './App.css';
import Home from "./Pages/Home/home.jsx"
import Navbar from "./Section/Home/Header/navbar.jsx"
import Privacy from './Section/Home/privacy/Privacy.jsx';
import Terravia from "./Pages/Terravia/Terravia.jsx"
import Tanakayu from "./Pages/Tanakayu/Tanakayu.jsx"
import Hiera from "./Pages/Hiera/Hiera.jsx"
import Eonna from "./Pages/Eonna/Eonna.jsx"
import Blizfield from "./Pages/Blizfield/Blizfield.jsx"
import Caelus from "./Pages/Caelus/Caelus.jsx"
import Tresor from "./Pages/Tresor/Tresor.jsx"
import Enchante from "./Pages/Enchante/Enchante.jsx"
import Navapark from "./Pages/Navapark/Navapark.jsx"
import Armont from "./Pages/Armont/Armont.jsx"
import Vireya from "./Pages/Vireya/Vireya.jsx"
import Izzi from "./Pages/Izzi/Izzi.jsx"
import Commercial from "./Pages/Commercial/komersial.jsx"
import Footer from "./Section/Home/Footer/footer.jsx"
import tombol from "./Media/tombol.webp"
import Scrolltohashelement from "./Pages/Home/ScrollToHashElement.js";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";



function App() {
  const fungsiganteng = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6282122005507&text=Halo%20Dean,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20BSD%20City%20https://bsdcity-marketing.id//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    
    <Router>
      <Scrolltohashelement/>
      <Navbar />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/vireya" element={<Vireya/>}/>
        <Route path="/izzi" element={<Izzi/>}/>
        <Route path="/terravia" element={<Terravia />} />
        <Route path="/tanakayu" element={<Tanakayu />} />
        <Route path="/hiera" element={<Hiera/>}/>
        <Route path="/eonna" element={<Eonna/>}/>
        <Route path="/armont" element={<Armont/>}/>
        <Route path="/blizfield" element={<Blizfield/>}/>
        <Route path="/caelus" element={<Caelus/>}/>
        <Route path="/tresor" element={<Tresor/>}/>
        <Route path="/enchante" element={<Enchante/>}/>
        <Route path="/navapark" element={<Navapark/>}/>
        <Route path="/commercial" element={<Commercial/>}/>
        
      </Routes>
      
      <Footer />
      <img
        onClick={fungsiganteng}
        src={tombol}
        className="tombolwa"
        alt="Hubungi Sekarang!"
      />
    </Router>
  );
}

export default App;